import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoginPaymentIframeComponent } from '../login-payment-iframe/login-payment-iframe.component';
import { BreakpointsService, MatBottomSheetService } from 'src/app/services';
import { BottomSheetConfig, BottomSheetData } from 'src/app/interfaces/mat.interface';
import { MPassService } from '../../services/mpass.service';

@Component({
  selector: 'app-sign-payment-card',
  standalone: true,
  imports: [
    TranslateModule,
  ],
  templateUrl: './sign-payment-card.component.html',
  styleUrls: ['./sign-payment-card.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class SignPaymentCardComponent {
  private _matBottomSheetService = inject(MatBottomSheetService);
  private _breakpointsService = inject(BreakpointsService);
  private _isMobile = computed(() => this._breakpointsService.isMobile());
  private _mpassService = inject(MPassService);
  private hashUrl = computed(() => this._mpassService.hashUrl());
  public errorMsg = computed(() => this._mpassService.errorMsg());
  
  public async openLoginIframeBottomSheet() {
    const bottomSheetConfig: BottomSheetConfig<LoginPaymentIframeComponent, BottomSheetData> = {
      component: LoginPaymentIframeComponent,
      panelClass: this._isMobile() ? 'login-payment-iframe-bottom-sheet--mobile' : 'login-payment-iframe-bottom-sheet--desktop',
    }    
    
    await this._matBottomSheetService.openMatBottomSheet(bottomSheetConfig);
  }

  openLoginExternalLink(){
    const url = `https://mpass.mobi/p360/?token=${this.hashUrl()}&appDestination=marketplace#/marketplace`;
    console.log("URL: ", url);
    window.open(url, "_blank");
  }

}
